module.exports = __webpack_public_path__ + "static/media/marker-vessel-jalan.dfe1ba8f.svg";